type JSONSchema =
  | {
      type: 'string' | 'number' | 'integer' | 'boolean' | 'null' | 'object' | 'array'
      [k: string]: any
    }
  | { anyOf?: JSONSchema[]; oneOf?: JSONSchema[]; allOf?: JSONSchema[] }
  | Record<string, any>

export function schemaToShape(schema: JSONSchema): string {
  // unions (very light handling)
  if (schema.anyOf) return schema.anyOf.map(schemaToShape).join(' | ')
  if (schema.oneOf) return schema.oneOf.map(schemaToShape).join(' | ')
  if (schema.allOf) return schema.allOf.map(schemaToShape).join(' & ')

  const t = (schema as any).type

  if (t === 'array') {
    const items = (schema as any).items ?? {}
    return `[${schemaToShape(items)}]`
  }

  if (t === 'object') {
    const props = (schema as any).properties ?? {}
    const required: string[] = (schema as any).required ?? []
    const lines: string[] = []

    for (const key of Object.keys(props)) {
      const isRequired = required.includes(key)
      const keyPart = JSON.stringify(key) + (isRequired ? '' : '?')
      lines.push(`${keyPart}: ${schemaToShape(props[key])}`)
    }

    // If no defined properties, show generic object
    if (!Object.keys(props).length) return 'object'

    return `{ ${lines.join(', ')} }`
  }

  switch (t) {
    case 'number':
    case 'integer':
      return 'number'
    case 'string':
    case 'boolean':
    case 'null':
      return t
    default:
      throw new Error('Invalid json schema')
  }
}
